import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    position: relative;
`;

export const ContentSearch = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    
    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
    `;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
    `;

export const Input = styled.input`
    border-radius: 4px;
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    padding: 10px;
    width: 100%;
`;

//PopMenu
export const ContentPopMenu = styled.div`
    width: 100%;
    position: relative;
`;

export const PopMenu = styled.div`
    position: absolute;
    z-index: 2;
    margin-top: 5px;
    width: 100%;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 5px 3px;

    max-height: 100px;
    overflow-y: scroll;
    

    &::-webkit-scrollbar { 
        display: none;
    }

    span{
        font-size: 14px;
        color: ${(props) => props.theme.colors.gray.gray_200};
        padding: 5px 10px;
    }
`;

export const ButtonMenu = styled.button`
  width: 100%;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;
  border-top: 1px solid ${(props) => props.theme.colors.gray.gray_50};

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
  }
`;
//Fim PopMenu